const Status = function () {
    this.fps = 0;
    let beginTime = (performance || Date).now();
    let prevTime = beginTime;
    let frames = 0;

    return {
        begin: function () {
            beginTime = (performance || Date).now();
        },
        end: function () {
            frames++;
            let time = (performance || Date).now();
            if (time > prevTime + 3000) {
                this.fps = (frames * 1000) / (time - prevTime);
                prevTime = time;
                frames = 0;
            }
            return time;
        },
        getFPS() {
            return this.fps;
        },
        update: function () {
            beginTime = this.end();
        },
    };
};

export default Status;
